export const guestListWithItems = (state, recordTypeId) =>
  state.guestLists.groupsByTypeId[recordTypeId] || [];
export const guestLists = state => state.guestLists.lists;
export const guestList = (state, recordTypeId) =>
  state.guestLists.lists.find(l => l.record_type_id === recordTypeId) || {};
